import React from 'react'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'

function Filter(props) {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    return (
        <div className="filter-standard">
            <div className="col">
                <select
                    name="status"
                    value={props.filter.status}
                    onChange={handleSearch}
                >
                    <option value="" selected>
                        {trans('random.selectStatus')}
                    </option>
                    <option value="pending">
                        {trans('random.pendding')}
                    </option>
                    <option value="closed">
                        {trans('random.closed')}
                    </option>
                </select>
            </div>

            <div className="col">
                <DateRange
                    startDate={props.filter.date}
                    endDate={props.filter.deadline}
                    onStartDateChange={(date) => {
                        props.handleSearch('date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('deadline', date)
                    }}
                />
            </div>

            <div className="col">
                <input
                    type="search"
                    name="search"
                    value={props.filter.search}
                    onChange={handleSearch}
                    placeholder={trans('labels.search')}
                />
            </div>
        </div>
    )
}

export default React.memo(Filter, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})